export const SET_SUB_NAVIGATION = 'SET_SUB_NAVIGATION'
export const SET_LIGHTBOX = 'SET_LIGHTBOX'
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU'
export const TOGGLE_MOBILE_FILTERS = 'TOGGLE_MOBILE_FILTERS'
